var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageHiBillEnergySavingTipTool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 323.358 323.358",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M48.863 323.358h225.632c23.653 0 42.875-19.222 42.875-42.875V66.827c0-23.653-19.222-42.875-42.875-42.875h-17.006V11.976c0-6.587-5.39-11.976-11.977-11.976s-11.976 5.389-11.976 11.976v11.976H89.822V11.976C89.822 5.389 84.432 0 77.845 0S65.869 5.389 65.869 11.976v11.976H48.863c-23.653 0-42.875 19.222-42.875 42.875v213.656c0 23.653 19.222 42.875 42.875 42.875zM29.941 66.827c0-10.419 8.503-18.922 18.922-18.922h17.006v11.976c0 6.587 5.389 11.976 11.976 11.976s11.976-5.389 11.976-11.976V47.905h143.715v11.976c0 6.587 5.389 11.976 11.976 11.976s11.976-5.389 11.976-11.976V47.905h17.006c10.419 0 18.922 8.503 18.922 18.922v34.971H29.941zm0 58.923h263.477v154.733c0 10.419-8.503 18.922-18.922 18.922H48.863c-10.419 0-18.922-8.503-18.922-18.922z",
    fill: "#00206d",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageHiBillEnergySavingTipTool);
export default __webpack_public_path__ + "static/media/manageHiBill-energy-saving-tipTool.d57ffa6a6f66fa75fbaced3754e50f9b.svg";
export { ForwardRef as ReactComponent };